<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="foreword">
<h1>Foreword</h1>
<p style="text-indent:0em !important"><em>Our life is twofold; Sleep hath its own world,</em></p>
<p style="text-indent:0em !important"><em>A boundary between the things misnamed.</em></p>
<p style="text-indent:0em !important"><em>Death and existence</em></p><br/>
<p style="text-indent:0em !important">Lord Byron</p><br/>
<p style="text-indent:0em !important"><em>The Dream</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?0751c6f2